import { PERMISSION } from "../../../components/rbac/permissions";
export var MASTER_CATALOGUE_MANAGE = [PERMISSION.FS_CATALOGUE_MANAGE_MASTER];
